<template>
  <el-popover
    :placement="placement"
    popper-class="fifl-popper"
    :visible-arrow="false"
    trigger="hover"
  >
    <span>
      <slot />
    </span>
    <img
      slot="reference"
      src="/image/icon/help.svg"
      :style="{width : iconSize + 'px'}"
    >
  </el-popover>
</template>

<script>
export default {
  name: 'Popover',
  props: {
    placement: {
      type: String,
      default: 'right-start'
    },
    iconSize: {
      type: Number,
      default: 17
    }
  }
};
</script>

<style lang="scss">
.fifl-popper {
  border: 1px solid #d3d3d3;
  color: #4a4a4a;
  letter-spacing: -0.8px;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(180, 180, 180, 0.1);
  & > span {
    line-height: 20px;

    a {
      color: #6c6c6c;
      text-decoration: #6c6c6c underline;
    }
  }
}
</style>
